<template>

  <!-- Page -->
  <div class="page-error">
    <div class="page vertical-align text-center" data-animsition-in="fade-in" data-animsition-out="fade-out">
      <div class="page-content vertical-align-middle">
        <header>
          <h1 class="animation-slide-top">404</h1>
          <p>Page Not Found !</p>
        </header>
        <!--<p class="error-advise">YOU SEEM TO BE TRYING TO FIND HIS WAY HOME</p>-->
        <!--<a class="btn btn-primary btn-round" href="../index.html">GO TO HOME PAGE</a>-->

        <footer class="page-copyright">
          <!--<p>WEBSITE BY Creation Studio</p>-->
          <p>© 2020 Repnode. All RIGHT RESERVED.</p>
          <div class="social">
            <a class="btn btn-icon btn-pure" href="javascript:void(0)">
              <i class="icon bd-twitter" aria-hidden="true"></i>
            </a>
            <a class="btn btn-icon btn-pure" href="javascript:void(0)">
              <i class="icon bd-facebook" aria-hidden="true"></i>
            </a>
            <a class="btn btn-icon btn-pure" href="javascript:void(0)">
              <i class="icon bd-dribbble" aria-hidden="true"></i>
            </a>
          </div>
        </footer>
      </div>
    </div>
  </div>
  <!-- End Page -->

</template>

<script>
import MyHeader from '../layout-header'
import LeftMenu from '../layout-left-menu'
import MyFooter from '../layout-footer'

export default {
  components: { LeftMenu, MyHeader, MyFooter }
}
</script>

<style scoped>
.page-error .error-mark {
  margin-bottom: 33px;
}

.page-error header h1 {
  font-size: 10em;
  font-weight: 400;
}

.page-error header p {
  margin-bottom: 30px;
  font-size: 30px;
  text-transform: uppercase;
}

.page-error h2 {
  margin-bottom: 30px;
}

.page-error .error-advise {
  margin-bottom: 25px;
  color: #a9afb5;
}

</style>
